import React from "react";
import { aboutContent } from "../mock";

const AboutSection = ({ setActiveSection, activeSection }) => {

  // ⭐ Banner should show only when activeSection === "about"
  const showBanner = activeSection === "about";

  return (
    <section id="about" className="bg-white text-gray-900">

      {/* ⭐ PREMIUM FULL-WIDTH HEADER WITH g7.jpg (ONLY IN ABOUT PAGE) */}
      {showBanner && (
        <div className="relative w-full h-[350px] md:h-[450px]">

          {/* Background */}
          <img
            src="/gallary/g7.jpg"
            alt="About Banner"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* ⭐ CENTER HEADING */}
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
              About Us
            </h1>
          </div>

          {/* ⭐ LEFT BOTTOM HEADING */}
          <div className="absolute bottom-0 left-0 w-full bg-black/40 py-4 px-6">
            <h2 className="text-xl md:text-2xl font-semibold text-white">
              About Us
            </h2>
          </div>

          {/* ⭐ RIGHT BOTTOM BREADCRUMB */}
          <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex items-center gap-2 text-white">
            <button
              onClick={() => setActiveSection("home")}
              className="hover:text-amber-300 transition"
            >
              Home
            </button>
            <span>›</span>
            <span className="text-amber-300">About Us</span>
          </div>

        </div>
      )}

      {/* 🔥 MAIN CONTENT (same as your original code) */}
      <div className="container mx-auto px-4 py-16">

        {/* ⭐ 1. Welcome Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 md:order-1">
            <img
              src={aboutContent.welcome.image}
              alt="Spa Interior"
              className="rounded-xl shadow-2xl w-full h-[500px] object-cover"
            />
          </div>

          <div className="order-1 md:order-2">
            <p className="text-amber-900 font-semibold text-lg">
              {aboutContent.welcome.subtitle}
            </p>

            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {aboutContent.welcome.title}
            </h2>

            {aboutContent.welcome.description.map((p, i) => (
              <p key={i} className="text-gray-600 mb-4 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>

        {/* ⭐ 2. Our Story */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {aboutContent.about.title}
            </h2>

            {aboutContent.about.description.map((p, i) => (
              <p key={i} className="text-gray-600 mb-4 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div>
            <img
              src={aboutContent.about.image}
              alt="Spa Treatment"
              className="rounded-xl shadow-2xl w-full h-[500px] object-cover"
            />
          </div>
        </div>

        {/* ⭐ 3. Highlights */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
          {[
            { title: "Luxury Ambience", text: "Relax in a calm, peaceful, and premium wellness environment." },
            { title: "Certified Therapists", text: "Highly trained experts ensuring complete relaxation & healing." },
            { title: "Premium Oils", text: "We use authentic aroma & herbal products for best results." },
            { title: "Hygiene & Safety", text: "We maintain strict hygiene for safe and peaceful services." },
          ].map((item, i) => (
            <div
              key={i}
              className="p-6 bg-white shadow-lg rounded-xl border hover:shadow-2xl transition-all"
            >
              <h3 className="text-xl font-bold text-amber-900 mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.text}</p>
            </div>
          ))}
        </div>

        {/* ⭐ CTA */}
        <div className="text-center mt-16">
          <button
            onClick={() => setActiveSection("booking")}
            className="bg-amber-900 text-white px-10 py-4 rounded-lg text-lg hover:bg-amber-800 transition-all hover:scale-105"
          >
            Book an Appointment
          </button>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
